<template>
  <v-list dense nav class="py-0">
    <slot></slot>
  </v-list>
</template>
<script>
export default {
  name: "Sidebar"
}
</script>
